import type { AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';
import i18n from 'i18n';
import Cookies from 'js-cookie';

const controller = new AbortController();
const signal = controller.signal;

const appApi = axios.create({
  baseURL: `${import.meta.env.VITE_APP_BASE_URL_LK}`,
  headers: {
    Authorization: `Bearer ${Cookies.get('session_id')}`,
    'Content-Type': 'application/json',
  },
  timeout: 10_000,
});

appApi.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers['Language'] = i18n.language;
    }

    return config;
  },
  (error: AxiosError<{ message: string }>) => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.message === 'Payment is not allowed in your country.'
    ) {
      // eslint-disable-next-line unicorn/prefer-global-this
      window.forbidden = true;
      controller.abort();
    }

    return Promise.reject(error);
  },
);

appApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message: string }>) => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.message === 'Payment is not allowed in your country.'
    ) {
      // eslint-disable-next-line unicorn/prefer-global-this
      window.forbidden = true;
      controller.abort();
    }

    return Promise.reject(error);
  },
);

const responseBody = <T>(response: AxiosResponse<{ result: T }>) => response.data?.result;

export const appApiExtract = {
  delete: <T>(url: string) => appApi.delete<{ result: T }>(url, { signal }).then(responseBody),

  get: <T>(url: string) => appApi.get<{ result: T }>(url, { signal }).then(responseBody),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post: <T>(url: string, body?: Record<string, any>) =>
    appApi.post<{ result: T }>(url, body, { signal }).then(responseBody),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  put: <T>(url: string, body?: Record<string, any>) =>
    appApi.put<{ result: T }>(url, body, { signal }).then(responseBody),
};

export default appApi;
